import styled, { keyframes } from "styled-components";

export const UploadBtnWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  input {
    display: none;
  }
`;
const LoadingKeyframe = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;

export const LoadingSpinner = styled.div`
  width: 2rem;
  height: 2rem;
  border: 3px solid rgb(82, 212, 235);
  border-top: 3px solid lightgray;
  border-radius: 50%;
  animation: ${LoadingKeyframe} 1.25s linear infinite;
`;

// 이거 겹친다.
export const UploadButton = styled.button`
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: none;
  font-size: 1.4rem;
  padding: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: whitesmoke;
  background-color: rgb(207, 109, 197);
  &:hover {
    opacity: 0.8;
  }
`;
